module.exports = __webpack_public_path__ + "static/media/icon_anexo_BIG.d623a761.svg";